import { supabase } from './supabase';

// ── WEBAUTHN: Face ID y huella digital ────────────────────
export const WA = {
  disponible: () => window.PublicKeyCredential !== undefined,
  b64ToBuffer: (b64) => {
    const bin = atob(b64.replace(/-/g,'+').replace(/_/g,'/'));
    return Uint8Array.from(bin, c => c.charCodeAt(0)).buffer;
  },
  bufferToB64: (buf) => {
    return btoa(String.fromCharCode(...new Uint8Array(buf)))
      .replace(/\+/g,'-').replace(/\//g,'_').replace(/=/g,'');
  },
  registrar: async (usuarioId, email) => {
    const challenge = crypto.getRandomValues(new Uint8Array(32));
    const safeEmail = String(email || 'usuario').trim() || 'usuario';
    const safeId    = String(usuarioId || 'user').trim() || 'user';
    const opts = {
      challenge,
      rp: { name: 'TandaClick', id: window.location.hostname },
      user: {
        id: new TextEncoder().encode(safeId),
        name: safeEmail,
        displayName: safeEmail,
      },
      pubKeyCredParams: [
        { alg: -7, type: 'public-key' },
        { alg: -257, type: 'public-key' },
      ],
      authenticatorSelection: {
        authenticatorAttachment: 'platform',
        userVerification: 'required',
        residentKey: 'discouraged',
        requireResidentKey: false,
      },
      attestation: 'none',
      timeout: 60000,
    };
    const cred = await navigator.credentials.create({ publicKey: opts });
    return {
      credentialId: WA.bufferToB64(cred.rawId),
      publicKey: WA.bufferToB64(cred.response.attestationObject),
      challenge: WA.bufferToB64(challenge),
    };
  },
  autenticar: async (credentialId) => {
    const challenge = crypto.getRandomValues(new Uint8Array(32));
    const opts = {
      challenge,
      allowCredentials: [{
        id: WA.b64ToBuffer(credentialId),
        type: 'public-key',
        transports: ['internal'],
      }],
      userVerification: 'required',
      timeout: 60000,
    };
    const assertion = await navigator.credentials.get({ publicKey: opts });
    return { ok: true, credentialId: WA.bufferToB64(assertion.rawId) };
  },
};

// ── AUDITORÍA: registra acciones críticas ──────────────────
export const audit = async (accion, detalle = {}) => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    await supabase.from('auditoria').insert({
      usuario_id: user?.id || null,
      accion,
      detalle: JSON.stringify(detalle),
      ua_hint: navigator.userAgent?.slice(0, 80) || null,
    });
  } catch (_) { /* audit nunca debe romper el flujo */ }
};

export const C = {
  primary: '#1A56DB', primaryDk: '#1344B8', primaryLt: '#EBF0FF', primaryMd: '#DBEAFE',
  accent: '#0EA5E9', success: '#059669', successLt: '#D1FAE5',
  danger: '#DC2626', dangerLt: '#FEE2E2', warning: '#D97706', warningLt: '#FEF3C7',
  white: '#FFFFFF', gray50: '#F8FAFC', gray100: '#F1F5F9', gray200: '#E2E8F0',
  gray400: '#94A3B8', gray600: '#475569', gray800: '#1E293B',
  text: '#1E293B', textMd: '#475569', textLt: '#94A3B8',
  oxxo: '#EE2E24',
};

export const fmt = (n) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 0 }).format(n);

// Helper: obtener URL de comprobante (compatible con paths y URLs legacy)
export const getComprobanteUrl = (comprobanteUrl) => {
  if (!comprobanteUrl) return null;
  // Si ya es una URL completa (legacy), devolverla tal cual
  if (comprobanteUrl.startsWith('http')) return comprobanteUrl;
  // Si es un path, generar URL pública desde Storage
  const { data } = supabase.storage.from('comprobantes').getPublicUrl(comprobanteUrl);
  return data?.publicUrl || null;
};
